const video = {
  btns: document.querySelectorAll('.jsLoadVideo') as NodeListOf<HTMLElement>,
  ele: document.getElementById('jsVideoPlayer') as HTMLElement,
  iframe: null as HTMLIFrameElement | null,

  init() {
    this.setVideo();
    this.pauseOnOutsideClick();
  },

  setVideo() {
    this.btns.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.stopPropagation();

        const videoId = btn.getAttribute('data-video-id');

        if (!videoId) return;

        this.ele.innerHTML = `
          <iframe 
            src="https://www.youtube.com/embed/${videoId}?autoplay=1&mute=0&enablejsapi=1" 
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
            allowfullscreen
            style="width: 100%; height: 100%; border: none;">
          </iframe>
        `;

        this.iframe = this.ele.querySelector('iframe');
      });
    });
  },

  pauseVideo() {
    if (!this.iframe?.contentWindow) return;

    this.iframe.contentWindow.postMessage(
      JSON.stringify({
        event: 'command',
        func: 'pauseVideo',
        args: [],
      }),
      '*'
    );
  },

  pauseOnOutsideClick() {
    document.addEventListener('click', (e) => {
      const target = e.target as HTMLElement;

      const clickedInsideVideo = this.ele.contains(target);
      const clickedVideoBtn = target.closest('.jsLoadVideo');

      if (!clickedInsideVideo && !clickedVideoBtn) {
        this.pauseVideo();
      }
    });
  },
};

export default video;